import { useCallback, useContext, useEffect } from 'react';
import { ChatbotWidgetContext } from '../utils/ChatbotWidgetContext';
import { fetchCCAIUserToken } from '../utils/fetchCCAIUserToken';
import { View } from '../constants/view';

export const useStartChat = (): (() => Promise<void>) => {
  const { setView, client, setClient, options, user } =
    useContext(ChatbotWidgetContext);
  const { name, email } = user;

  const startChat = useCallback(async (): Promise<void> => {
    const { Client } = await import('@ujet/websdk-headless');

    const client = new Client({
      companyId: options.companyId,
      host: options.host,
      authenticate: fetchCCAIUserToken(options.apiUrl, { name, email })
    });

    setClient(client);
  }, [ name, email, options, setClient ]);

  useEffect(() => {
    if (!client) return;

    const createChat = async (): Promise<void> => {
      await client.createChat(options.menuId, { lang: 'en' });
      setView(View.CHAT);
    };

    client.on('ready', () => {
      createChat();
    });

    return (): void => {
      client.off('ready', () => {
        createChat();
      });
    };
  }, [ client, options.menuId, setView ]);

  return startChat;
};
